import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { EditWebcastComponent } from 'rev-portal/scheduledEvents/editWebcast/EditWebcast.Component';
import { IMediaFeatures } from 'rev-shared/media/IMediaFeatures';
import { INotifications } from 'rev-portal/scheduledEvents/webcast/Webcast.Contract';
import { MediaFeaturesService } from 'rev-shared/media/MediaFeatures.Service';
import { ThemeService } from 'rev-portal/branding/Theme.Service';
import { WebcastModel } from 'rev-portal/scheduledEvents/webcast/model/WebcastModel';
import { WebcastVideoSource } from 'rev-portal/scheduledEvents/webcast/WebcastVideoSource';

import { WebcastViewSidebarButton } from './WebcastViewSidebarButtonModel';
import styles from './WebcastViewSidebarPanel.Component.module.less';
import { IWebcastViewContext } from './IWebcastViewContext';
import { WebcastViewQuestionsService } from './questions/WebcastViewQuestions.Service';

@Component({
	selector: 'webcast-view-sidebar-panel',
	templateUrl: './WebcastViewSidebarPanel.Component.html',
	host: {
		'[class]': 'styles.root'
	},
	standalone: false
})
export class WebcastViewSidebarPanelComponent {
	@Input() public readonly accountId: string;
	@Input() public webcast: WebcastModel;
	@Input() public sidebarNotifications: INotifications;
	@Input() public selectedButtonId: string;
	@Input() public webcastViewContext: IWebcastViewContext;
	@Input() public inlineEdit: boolean;
	@Input() public isAttendeesPollingActive: boolean;

	@Output() public inlineEditCompleted: EventEmitter<any> = new EventEmitter();
	@Output() public sourceRestartInitiated: EventEmitter<string> = new EventEmitter();
	@Output() public switchStreamInitiated: EventEmitter<void> = new EventEmitter();

	@ViewChild(EditWebcastComponent)
	public editWebcastComponent: EditWebcastComponent;

	public mediaFeatures: IMediaFeatures;

	public readonly WebcastViewSidebarButton = WebcastViewSidebarButton;
	public readonly styles = styles;
	public dtmfCodesToReject: string;

	constructor(
		private readonly MediaFeatures: MediaFeaturesService,
		private readonly WebcastViewQuestionsService: WebcastViewQuestionsService,
		public ThemeService: ThemeService
	) {}

	public ngOnInit(): void {
		if (this.webcast.questionAndAnswerEnabled && !this.webcast.currentUser.canManageQuestions) {
			this.WebcastViewQuestionsService.subscribeAttendeeHandlers(this.webcast, this.sidebarNotifications.questions);
		}
		this.MediaFeatures.getFeatures()
			.then(result => {
				this.mediaFeatures = result;
				switch (this.webcast.videoSource) {
					case WebcastVideoSource.PEXIP:
						this.dtmfCodesToReject = this.mediaFeatures.pexipSettings?.dtmfInfo?.codesToReject;
						break;

					case WebcastVideoSource.SIP_ADDRESS:
						this.dtmfCodesToReject = this.mediaFeatures.vciSettings?.dtmfInfo?.codesToReject;
						break;

					case WebcastVideoSource.ZOOM:
						this.dtmfCodesToReject = this.mediaFeatures.zoomSettings?.dtmfInfo?.codesToReject;
						break;

					default:
						break;
				}
			});
	}
}
